import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from "./SofiaShopifyApi.module.css";
import { BounceLoader } from "react-spinners";
import { getBatchShopifySofia } from "../../../redux/actions/apiActions";
import SofiaShopifyItems from "../SofiaShopifyItems/SofiaShopifyItems";
import Pagination from "../../../components/Paginate/paginate";

function SofiaShopifyApi() {
  const dispatch = useDispatch();
  const { batchShopifySofia, loading, paginate } = useSelector((state) => state.apiData);

  useEffect(() => {
    dispatch(getBatchShopifySofia(1));
  }, [dispatch]);

      const handlePageChange = (page) => {
      dispatch(getBatchShopifySofia(page)); 
    };
    
  return (
    <div className={loading ? style.shopifyApiContainerLoading : style.vtexApiContainer}>
      {loading ? (
        <BounceLoader className={style.spinner} color="#61a030" />
      ) : (
        <>
          <div className={style.vtexApiEncabezado}>
            <ul className={`${style.uLlist} nav row`}>
              {["Total Elementos", "Fecha de Inicio", "Fecha de fin", "Duración", "Estado", "Llamar ahora","Descargar CSV"].map((text, idx) => (
                <li key={idx} className="nav-item col">
                  <span className="nav-link">{text}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
             {batchShopifySofia?.map((batch, idx) => (
              <SofiaShopifyItems key={batch._id || idx} item={batch} />
            ))} 
          </div>
        </>
      )}
          <div>
        <Pagination paginate={paginate} isLoading={loading} onPageChange={handlePageChange} />
      </div>
    </div>
  );
}

export default SofiaShopifyApi;
